import Listing from "../../Listing";
import React, { useEffect } from "react";
import Header from "../../../../layout/Header";
import Footer from "../../../../layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import HeroSection from "../../../../layout/HeroSection";
import Loader from "../../../../components/other/Loader";
import { pageRoutes } from "../../../../routes/pageRoutes";
import { fetchlessonFusion } from "../../../../redux/action/lessonsAction";
import SecureContent from "../../../../components/secureContent";

const Fusion = () => {
  const dispatch = useDispatch();
  const { fusionList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonFusion());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Fusion"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            // {
            //   name: "3D modeling",
            //   path: pageRoutes?.lessons?.threeDModling,
            // },
            { name: "Fusion", path: `${pageRoutes?.home}/` },
          ]}
        />

        <Listing contentData={fusionList} />

        <Footer />
      </div>
    </>
  );
};

export default Fusion;
